import { ScrollCaptain } from 'scroll-captain';

class StickyBulbs {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-stickybulbs',
            targetValue: 'bulbs',
            wrapperValue: 'wrapper',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$stickyBulbs = element;
    }

    initialize() {
        this.toggleBubls();
    }

    toggleBubls() {
        this.animation = new ScrollCaptain(this.$stickyBulbs, {
            initAttr: this.settings.initAttr,
            top: '48%',
            bottom: '-48%',
            animateBulbs: {
                globalTarget: true,
                targetSuffix: this.settings.targetValue,
                class: 'researchAiLandingpage-stickyBulbs--visible',
            },
            animateBackground: {
                globalTarget: true,
                targetSuffix: this.settings.wrapperValue,
                class: 'researchAiLandingpage-stickyBulbsWrapper--visible',
            },
        });
    }
}

export { StickyBulbs };
